// 健康管理模块配置
export const healthConfig = {
  // 模块基本信息
  name: '健康管理',
  description: '打卡、监测、预防',
  icon: 'HeartOutlined',
  bgColor: '#FF6B6B',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    checkins: '/health/checkins',
    create: '/health/create',
    update: '/health',
    delete: '/health',
    monthly: '/health/monthly',
    stats: '/health/stats'
  },
  
  // 健康打卡分类
  healthCategories: [
    {
      key: 'diet',
      name: '饮食',
      icon: '🍎',
      color: '#FF6B6B',
      items: [
        {
          key: 'vegetables_fruits',
          question: '今天是否吃够了3种以上蔬菜、2种水果?',
          type: 'checkbox'
        },
        {
          key: 'oil_salt_sugar',
          question: '是否控制了油盐糖?',
          description: '(少油、少盐、少饮料/甜食)',
          type: 'checkbox'
        },
        {
          key: 'protein',
          question: '是否吃了优质蛋白?',
          description: '(鸡蛋、鱼、瘦肉、豆制品、牛奶)',
          type: 'checkbox'
        },
        {
          key: 'portion_control',
          question: '是否避免暴饮暴食,做到七八分饱?',
          type: 'checkbox'
        }
      ]
    },
    {
      key: 'exercise',
      name: '运动',
      icon: '🏃',
      color: '#4ECDC4',
      items: [
        {
          key: 'cardio',
          question: '今天有没有进行≥30分钟的中等强度运动?',
          description: '(快走、慢跑、骑车等)',
          type: 'checkbox'
        },
        {
          key: 'strength_training',
          question: '一周是否完成了≥2次力量训练?',
          description: '(深蹲、俯卧撑、哑铃等)',
          type: 'checkbox'
        },
        {
          key: 'reduce_sitting',
          question: '是否减少久坐,每隔1小时起来活动一下?',
          type: 'checkbox'
        }
      ]
    },
    {
      key: 'sleep',
      name: '睡眠',
      icon: '😴',
      color: '#45B7D1',
      items: [
        {
          key: 'sleep_hours',
          question: '是否保证了7-9小时睡眠?',
          type: 'checkbox'
        },
        {
          key: 'early_bed',
          question: '是否在23点前上床,避免熬夜?',
          type: 'checkbox'
        },
        {
          key: 'bedtime_habits',
          question: '是否在睡前减少刷手机/饮咖啡/喝酒?',
          type: 'checkbox'
        }
      ]
    },
    {
      key: 'mental',
      name: '心理健康',
      icon: '🧘',
      color: '#96CEB4',
      items: [
        {
          key: 'relaxation',
          question: '今天是否进行了放松活动?',
          description: '(冥想、深呼吸、听音乐等)',
          type: 'checkbox'
        },
        {
          key: 'emotion_expression',
          question: '是否及时表达和调节情绪?',
          type: 'checkbox'
        },
        {
          key: 'social_interaction',
          question: '是否与家人朋友保持良好互动?',
          type: 'checkbox'
        }
      ]
    },
    {
      key: 'medical',
      name: '医疗管理',
      icon: '🏥',
      color: '#FFEAA7',
      items: [
        {
          key: 'medication',
          question: '是否按时服药(如有)?',
          type: 'checkbox'
        },
        {
          key: 'health_checkup',
          question: '是否定期体检?',
          type: 'checkbox'
        },
        {
          key: 'risk_avoidance',
          question: '是否避免健康风险行为?',
          description: '(戒烟、限酒、安全驾驶等)',
          type: 'checkbox'
        }
      ]
    }
  ],
  
  // 健康管理核心理念
  healthManagementCore: {
    title: '科学健康管理的核心理念',
    sections: [
      {
        title: '以预防为主',
        subtitle: '早筛查、早发现、早干预',
        items: [
          '定期体检，及时发现健康问题',
          '建立健康档案，跟踪健康趋势',
          '预防胜于治疗，防患于未然'
        ]
      },
      {
        title: '数据化管理',
        subtitle: '通过数据跟踪趋势，发现风险点',
        items: [
          '记录健康数据，建立个人健康档案',
          '分析健康趋势，识别潜在风险',
          '制定个性化健康管理方案'
        ]
      },
      {
        title: '全方位管理',
        subtitle: '身体、心理、生活习惯、环境影响',
        items: [
          '身体健康的全面监测',
          '心理健康的关注和维护',
          '生活习惯的改善和优化'
        ]
      },
      {
        title: '个性化管理',
        subtitle: '根据个人情况制定不同方案',
        items: [
          '考虑年龄、性别、遗传背景',
          '结合个人生活习惯和偏好',
          '制定适合的健康管理计划'
        ]
      }
    ]
  },
  
  // 科学健康管理的五大要素
  healthElements: {
    title: '科学健康管理的五大要素',
    sections: [
      {
        title: '饮食管理 🍎',
        subtitle: '均衡饮食，控制总热量',
        items: [
          '碳水、蛋白、脂肪、维生素、矿物质合理搭配',
          '控制总热量，少油少盐少糖',
          '多蔬菜水果，少加工食品'
        ]
      },
      {
        title: '运动管理 🏃',
        subtitle: '每周≥150分钟中等强度有氧运动',
        items: [
          '每周≥150分钟中等强度有氧运动（快走、游泳、骑车）',
          '每周≥2次力量训练（维持肌肉和骨骼）',
          '避免久坐，增加日常活动量'
        ]
      },
      {
        title: '睡眠管理 😴',
        subtitle: '成年人建议每天7-9小时高质量睡眠',
        items: [
          '成年人建议每天7-9小时高质量睡眠',
          '规律作息，避免熬夜',
          '创造良好的睡眠环境'
        ]
      },
      {
        title: '心理管理 🧘',
        subtitle: '学会情绪调节，保持良好人际关系',
        items: [
          '学会情绪调节（冥想、运动、倾诉、写日记）',
          '保持良好人际关系',
          '避免长期压力，学会放松'
        ]
      },
      {
        title: '医疗与风险管理 🏥',
        subtitle: '定期体检，科学用药',
        items: [
          '定期体检（血压、血糖、血脂、肿瘤筛查）',
          '有慢性病要科学用药，长期监测',
          '接种必要的疫苗'
        ]
      }
    ]
  },
  
  // 健康建议
  healthAdvice: {
    title: '健康管理建议',
    sections: [
      {
        title: '日常健康习惯',
        items: [
          '每天喝8杯水，保持身体水分',
          '多吃蔬菜水果，补充维生素',
          '规律作息，保证充足睡眠',
          '适量运动，增强体质',
          '保持心情愉悦，减少压力'
        ]
      },
      {
        title: '预防保健',
        items: [
          '定期体检，早发现早治疗',
          '接种疫苗，预防传染病',
          '注意个人卫生，预防疾病',
          '避免不良习惯，保护健康',
          '学习健康知识，提高健康素养'
        ]
      },
      {
        title: '慢性病管理',
        items: [
          '遵医嘱用药，定期复查',
          '控制饮食，合理运动',
          '监测指标，及时调整',
          '保持良好心态，积极配合治疗',
          '建立健康档案，跟踪病情变化'
        ]
      }
    ]
  },
  
  // 健康目标
  healthGoals: {
    title: '健康管理目标',
    goals: [
      {
        title: '短期目标',
        items: [
          '建立每日健康打卡习惯',
          '改善一项不良生活习惯',
          '增加运动频率和强度',
          '改善睡眠质量'
        ]
      },
      {
        title: '中期目标',
        items: [
          '达到理想体重和BMI',
          '提高心肺功能和肌肉力量',
          '改善各项健康指标',
          '建立健康的生活方式'
        ]
      },
      {
        title: '长期目标',
        items: [
          '预防慢性疾病的发生',
          '保持身体和心理的健康状态',
          '提高生活质量和幸福感',
          '延长健康寿命'
        ]
      }
    ]
  },
  
  // 打卡统计
  checkinStats: {
    title: '打卡统计',
    stats: [
      {
        title: '连续打卡',
        key: 'streak',
        unit: '天',
        color: '#52C41A'
      },
      {
        title: '本月打卡',
        key: 'monthly',
        unit: '次',
        color: '#1890FF'
      },
      {
        title: '完成率',
        key: 'completion',
        unit: '%',
        color: '#FAAD14'
      }
    ]
  }
};
